import React, { useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import NavbarComp from '../../shared/components/Navbar';
import { IoAddCircleOutline } from 'react-icons/io5';
import AgeGroupProductsAddModal from './components/AgeGroupProductsAddModal';
import AgeGroupProductsTable from './components/AgeGroupProductsTable';
import AlertMessage from '../../shared/components/Alert';
import { useAgeGroupProducts } from './hooks/useAgeGroupProducts';

const AgeGroupProductsPage = () => {

  const {
    ageGroupProduct,
    loading,
    error,
    addAgeGroupProduct,
    editAgeGroupProduct,
    fetchAgeGroupProductById,
    fetchAgeGroupProducts,
    removeAgeGroupProduct,
    updateOnActive,
    alert } = useAgeGroupProducts();

  const [showModal, setShowModal] = useState(false);

  const [editingData, setEditingData] = useState(null);

  const handleOpenModal = (row) => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingData(null);  // Reset after closing
  };

  const handleEditAgeGroupProduct = (updatedAgeGroupProduct) => {
    setEditingData(updatedAgeGroupProduct)
    handleOpenModal(updatedAgeGroupProduct)
  };

  const handleDeleteAgeGroupProduct = (id) => {
    removeAgeGroupProduct(id);
  };

  return (
    <>
      <NavbarComp />
      <AlertMessage show={alert.show} variant={alert.variant} message={alert.message} onClose={() => { }} />
      <Container fluid className="mt-2 mt-md-5">
        <Button Tooltip={"test"} variant="outline-success" className="mb-2" onClick={handleOpenModal}>
          <IoAddCircleOutline size={32} />
        </Button>
        <AgeGroupProductsTable
          ageGroupProducts={ageGroupProduct}
          onEdit={handleEditAgeGroupProduct}
          onDelete={handleDeleteAgeGroupProduct}
          updateOnActive={updateOnActive}
        />
        <AgeGroupProductsAddModal
          show={showModal}
          handleClose={handleCloseModal}
          handleAddProduct={addAgeGroupProduct}
          parsingDataEdit={editingData}
        />
      </Container>
    </>
  );
};

export default AgeGroupProductsPage;
